import React from 'react'

import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'

import { IApplicationState } from '@store'
import { isSupportedPCRMetricsChannel, selectShowEmptyState } from '@store/postCampaignReport'
import { selectPcrMetricIds } from '@store/postCampaignReport/metrics/selectors'
import { selectActivePCRChannel, selectCampaignId } from '@store/router'
import PostCampaignReportSubmissionListEmpty from '../Empty/Empty'
import PostCampaignReportSubmissionList from '../List'

export interface IInternalProps {
  showEmptyState?: boolean
}

const PostCampaignReportSubmissionListWrapper: React.FC<IInternalProps> = ({ showEmptyState }) => {
  if (showEmptyState) {
    return <PostCampaignReportSubmissionListEmpty />
  }

  return <PostCampaignReportSubmissionList />
}

const PostCampaignReportSubmissionListWrapperConnected: React.FC = () => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match)!
  const activeChannel = useSelector((state: IApplicationState) => selectActivePCRChannel(state))
  const showEmptyState = useSelector((state: IApplicationState) => {
    if (isSupportedPCRMetricsChannel(activeChannel)) {
      return selectPcrMetricIds(state, activeChannel, campaignId).length === 0
    }
    return selectShowEmptyState(state, campaignId, activeChannel)
  })
  return <PostCampaignReportSubmissionListWrapper showEmptyState={showEmptyState} />
}

export { PostCampaignReportSubmissionListWrapper }
export default PostCampaignReportSubmissionListWrapperConnected
